import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { Select } from 'hb-react/shared/components/formik/components/inputs';

export const Experience = () => {
  const { experienceTypes = [] } = useJobContext();

  const options = experienceTypes.map(({ id, name }) => ({
    id,
    name: I18n.t(name),
  }));

  return (
    <Select
      label={s__('JobForm|Years of experience')}
      name="experience_type_id"
      options={options}
    />
  );
};
